import { useEffect, useRef } from 'react'; // Removed useState import
import { Link } from 'react-router-dom';
import { FaArrowLeft } from "react-icons/fa";
import '../index2.css';
import styles from './DropdownMobil.module.css';

export default function DropdownMobil(props) {

    const dropdownMenuRef = useRef();

    const handleClick = () => {
        props.setDropDown(false);
        if (props.mobileMenu) {
            props.handleClickMobilMenu();
        }
        props.showMenuButtons();
    };

    const handleBackClick = () => {
        props.setDropDown(false);
        props.showMenuButtons();
    };

    useEffect(() => {
        if (props.dropdown && props.mobileMenu) {
            dropdownMenuRef.current.classList.add(styles.navDropdownMenuShow);
        } else {
            dropdownMenuRef.current.classList.remove(styles.navDropdownMenuShow);
        }
    }, [props.dropdown, props.mobileMenu]); // Added props.mobileMenu to dependencies

    return (
        <div ref={dropdownMenuRef} className={styles.navDropdownMenu}>
            <button className={styles.backArrow} onClick={handleBackClick}>
                <FaArrowLeft />
            </button>
            <ul className={styles.navDropdown}> 
                {props.items.map(item => {
                    return (
                        <li key={item.id} className={styles.navDropdownMenuItems} onClick={handleClick}>
                            <Link to={item.path} className={styles[item.cName]}>{item.title}</Link>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}
